/**
 * In this file, we create a React component
 * which incorporates components provided by Material-UI.
 */
import React from 'react';
import queryString from 'query-string';
import Helmet from 'react-helmet';

import { WithLocalize } from '../../containers/I18nProvider';
import RequestLoginErrorMessage from '../../components/RequestLoginErrorMessage';
import ServiceApi from '../../services/ServiceApi';

import './style.scss';
import favicon from './img/favicon.ico';
import LoginForm from './LoginForm';

class Login extends React.Component {

  constructor(props, context) {
    super(props, context);

    this.api = new ServiceApi(this);
    this.parameters = queryString.parse(props.location.search);
    props.changeDefaultLocale('es');
  }

  _validateParams() {
    if (!this.parameters.client_id || !this.parameters.redirect_uri || !this.parameters.response_type) {
      return false;
    }
    return true;
  }

  componentDidMount() {
    document.body.className = 'hvtv-body';
    document.title = 'Bienvenidos a HVPlay | HV Televisión';
  }

  render() {
    const { translate } = this.props;

    return (
      <div className="hvtv-container">
        <Helmet>
          <link rel="icon" type="image/png" href={favicon} sizes="16x16" />
        </Helmet>
        <main className="container-hvtv">
          {
            this._validateParams()
              ? <LoginForm
                api={this.api}
                location={this.props.location}
              />
              : <RequestLoginErrorMessage
                onlyMessage={true}
                message={translate('RequestLoginErrorMessage')}
              />
          }
        </main>
      </div>
    );
  }
}

export default WithLocalize(Login);
